import React from 'react';
import StarIcon from '@heroicons/react/outline/StarIcon.js';
import { BlockType } from '../../types/index.js';
import { LeaderboardBlock as Component } from './Block.js';
import { DEFAULT_MEMBERS_COUNT } from './constants.js';
import { LeaderboardBlockSettings as Settings } from './Settings.js';
export const RegisteredLeaderboardBlock = ({ $t, }) => {
    return {
        recommendedName: 'Leaderboard',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.Leaderboard.DisplayName',
                defaultMessage: 'Leaderboard',
            }),
            Settings,
            Icon: React.createElement(StarIcon, null),
            defaultProps: {
                heading: $t({
                    id: 'Generics.Leaderboard',
                    defaultMessage: 'Leaderboard',
                }),
                spaceId: '',
                membersCount: DEFAULT_MEMBERS_COUNT,
                showScore: true,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map